import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'app/services/authguard-service';
import { AppDetailsComponent } from './app-details.component';

const appRoutes: Routes = [
  {
    path: '', component: AppDetailsComponent, canActivate: [AuthGuard],
  }
];

export const appRoutingProviders: any[] = [

];

export const routing: ModuleWithProviders<any> = RouterModule.forChild(appRoutes);
